const searchModal = document.querySelector('[data-header-search] .header__search__inner');
const closeSearch = searchModal?.querySelector('.voyado-search .close-container');

function closeVoyadoSearch() {
  document.querySelector('[data-header-search] details-modal')?.close?.();
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeVoyadoSearch();
});

closeSearch?.addEventListener('click', (event) => {
  // Only close when the visible close control is clicked — not the
  // transparent area of the full-width container, which overlaps the input.
  if (!event.target.closest('.close, .close-text')) return;
  closeVoyadoSearch();
});

// Backdrop click: close only when the click lands directly on one of the
// search overlay's background containers — not the input, cards, links or
// buttons inside it. (DetailsModal's own outside-click handler can't catch
// these because the overlay is fixed/full-screen and lives inside it.)
const BACKDROP_CLASSES = [
  'search-modal',
  'modal-overlay',
  'search-modal__content',
  'voyado-container',
  'voyado-results-container',
  'voyado-search',
];
searchModal?.addEventListener('click', (event) => {
  if (!BACKDROP_CLASSES.some((cls) => event.target.classList.contains(cls))) return;
  closeVoyadoSearch();
});

/* invalid card */
function isValidProductCard(html) {
  return (
    html.includes('prd-Card') &&
    !html.includes('template-404') &&
    !html.includes('Page Not Found') &&
    !html.includes('shopify-section-header') &&
    !html.includes('<title>404</title>')
  );
}

/* ORDERED PRODUCT RENDERING */
const renderedHandles = new Set();
let lastRenderedProductSignature = '';

function getRenderableProducts(productGroups) {
  const items = [];
  const seen = new Set();

  productGroups.slice(0, 4).forEach((group) => {
    const product = group.products?.[0];
    if (!product?.link || seen.has(product.link)) return;

    seen.add(product.link);
    items.push({ link: product.link, ticket: product.ticket });
  });

  return items;
}

function getProductSignature(items) {
  return items.map((item) => item.link).join('|');
}

function clearProductResults() {
  if (!productList) return;

  productList.innerHTML = '';
  renderedHandles.clear();
  lastRenderedProductSignature = '';
}

function getProductInfo(linkHandle) {
  const productList = searchModal?.querySelector('.voyado-results__results--products');
  const link = `${window.location.origin}${linkHandle}?view=simple`;

  fetch(link)
    .then(res => {
      if (res.status === 404) return null;
      return res.text();
    })
    .then(html => {
      if (!html) return;
      if (!isValidProductCard(html)) return;
      if (html.includes('prd-Card_Title-soldOut')) return;

      const slot = productList.querySelector(`[data-handle="${linkHandle}"]`);
      if (!slot) return;

      slot.innerHTML = html;
      slot.classList.add('auto-Card');
    })
    .catch(() => { });
}

const v_search = searchModal?.querySelector('#voyado-search-input');
const suggestionsList = searchModal?.querySelector('.voyado-results__results');
const productList = searchModal?.querySelector('.voyado-results__results--products');
const viewAll = searchModal?.querySelectorAll('.prods__footer a') || [];

let cachedForYou = null;

function renderProducts(productGroups = []) {
  if (!productList) return;

  const items = getRenderableProducts(productGroups);
  const signature = getProductSignature(items);

  if (!items.length) {
    if (!lastRenderedProductSignature) return;
    clearProductResults();
    return;
  }

  if (signature === lastRenderedProductSignature) {
    const ticketsByLink = new Map(items.map((item) => [item.link, item.ticket]));
    productList.querySelectorAll(':scope > [data-handle]').forEach((slot) => {
      const ticket = ticketsByLink.get(slot.dataset.handle);
      if (ticket) slot.dataset.ticket = ticket;
    });
    return;
  }

  lastRenderedProductSignature = signature;

  const slotByHandle = new Map();
  productList.querySelectorAll(':scope > [data-handle]').forEach((slot) => {
    slotByHandle.set(slot.dataset.handle, slot);
  });

  const desiredLinks = items.map((item) => item.link);

  slotByHandle.forEach((slot, link) => {
    if (!desiredLinks.includes(link)) {
      slot.remove();
      slotByHandle.delete(link);
    }
  });

  const orderedSlots = items.map(({ link, ticket }) => {
    let slot = slotByHandle.get(link);

    if (!slot) {
      slot = document.createElement('div');
      slot.dataset.handle = link;
      slotByHandle.set(link, slot);
    }

    slot.dataset.ticket = ticket;
    return slot;
  });

  const needsReorder =
    orderedSlots.length !== productList.children.length
    || orderedSlots.some((slot, index) => productList.children[index] !== slot);

  if (needsReorder) {
    productList.replaceChildren(...orderedSlots);
  }

  renderedHandles.clear();
  items.forEach(({ link }) => renderedHandles.add(link));

  items.forEach(({ link }) => {
    const slot = slotByHandle.get(link);
    if (slot?.classList.contains('auto-Card')) return;

    getProductInfo(link);
  });
}

function renderSuggestions(suggestions = []) {
  if (!suggestionsList) return;

  suggestionsList.innerHTML = '';

  suggestions.forEach((suggestion) => {
    const formatted = suggestion.highlighted
      .replace(/{/g, '<span>')
      .replace(/}/g, '</span>');

    const clean = suggestion.q ?? suggestion.highlighted
      .replace(/{/g, '')
      .replace(/}/g, '');

    const item = document.createElement('div');
    item.className = 'voyado-results__suggestion-item';

    item.innerHTML = `
      <div class="result">
        <a href="/search?q=${encodeURIComponent(clean)}&origin=PHRASE_SUGGEST">${formatted}</a>
      </div>
    `;

    suggestionsList.appendChild(item);
  });

  suggestionsList.style.display = suggestions.length ? 'block' : 'none';
}

function setViewAllSearch(query) {
  viewAll.forEach((item) => {
    item.querySelector('.text').textContent = 'view all';
    item.href = `/search?q=${encodeURIComponent(query)}`;
  });
}

function showSearchState(query) {
  const resultsContainer = searchModal?.querySelector('.voyado-results-container');
  const resultsInit = searchModal?.querySelector('.results-container-init');
  const productsHeading = searchModal?.querySelector('.voyado-results--products h2');
  const productsCopy = searchModal?.querySelector('.voyado-results--products p');
  const onloadSuggestions = searchModal?.querySelector('.voyado-results__results--onload');

  if (resultsContainer) resultsContainer.style.display = 'grid';
  if (resultsInit) resultsInit.style.display = 'none';
  if (productList) productList.style.display = 'grid';
  if (productsHeading) productsHeading.textContent = 'Trending Results';
  if (productsCopy) productsCopy.innerHTML = '';
  if (onloadSuggestions) onloadSuggestions.classList.remove('active');

  setViewAllSearch(query);
}

function showForYouState(type) {
  const resultsInit = searchModal?.querySelector('.results-container-init');
  const productsHeading = searchModal?.querySelector('.voyado-results--products h2');
  const productsCopy = searchModal?.querySelector('.voyado-results--products p');
  const onloadSuggestions = searchModal?.querySelector('.voyado-results__results--onload');

  if (resultsInit) resultsInit.style.display = 'grid';
  if (productList) productList.style.display = 'grid';
  if (productsHeading) {
    productsHeading.textContent = type === 'empty' ? 'Picked for you' : 'Trending Results';
  }
  if (productsCopy) {
    productsCopy.innerHTML = type === 'empty'
      ? ''
      : '<span class="none-found">No results could be found</span><span class="try-something">Refine your search or explore trending pieces below.</span>';
  }

  viewAll.forEach((item) => {
    item.querySelector('.text').textContent = 'Shop all';
    item.href = '/collections/all';
  });

  if (onloadSuggestions) {
    onloadSuggestions.classList.toggle('active', type === 'empty');
  }
}

let autocompleteRequestId = 0;
let resultsUiMode = null;

function enterSearchUi(query) {
  if (resultsUiMode === 'search') {
    setViewAllSearch(query);
    return;
  }

  showSearchState(query);
  resultsUiMode = 'search';
}

function enterForYouUi(type) {
  if (resultsUiMode === type) return;

  showForYouState(type);
  resultsUiMode = type;
}

async function getForYouResults() {
  if (cachedForYou) return cachedForYou;

  const res = await window.elevate.api.query.landingPage(
    { pageReference: '/', notify: window.elevate.predictedConsent },
    {
      recommendationLists: [
        { id: 'PERSONAL-1', algorithm: 'PERSONAL' },
      ],
    },
  );

  cachedForYou = res?.recommendationLists?.[0]?.productGroups || [];

  return cachedForYou;
}

function applyAutocompleteResult(result, query) {
  const hasProductSuggestions = (result.productSuggestions?.length ?? 0) > 0;
  const hasPhraseSuggestions = (result.phraseSuggestions?.length ?? 0) > 0;
  const totalHits = Number(result.totalHits) || 0;
  const phraseSuggestions = result.phraseSuggestions ?? [];

  // Phrase-only with zero product hits: show suggestions + no-results copy + recs
  // (matches pre–productSuggestions-fix behaviour when totalHits was required).
  if (!hasProductSuggestions && hasPhraseSuggestions && totalHits === 0) {
    enterForYouUi('no-results');
    renderSuggestions(phraseSuggestions);
    return getForYouResults().then((recs) => {
      renderProducts(recs);
    });
  }

  if (!hasProductSuggestions && !hasPhraseSuggestions) {
    enterForYouUi('no-results');
    renderSuggestions([]);
    return getForYouResults().then((recs) => {
      renderProducts(recs);
    });
  }

  enterSearchUi(query);
  renderSuggestions(phraseSuggestions);

  if (hasProductSuggestions) {
    renderProducts(result.productSuggestions);
    return Promise.resolve();
  }

  clearProductResults();
  return Promise.resolve();
}

/* MAIN SEARCH HANDLER */
v_search?.addEventListener('input', async (event) => {
  const query = event.target.value.trim();
  const requestId = ++autocompleteRequestId;

  try {
    if (!query) {
      enterForYouUi('empty');
      const recs = await getForYouResults();
      if (requestId !== autocompleteRequestId) return;

      renderProducts(recs);
      if (suggestionsList) suggestionsList.innerHTML = '';
      return;
    }

    const result = await window.elevate.api.query.autocomplete({
      q: query,
      notify: window.elevate.trackingConsentGranted,
    });
    if (requestId !== autocompleteRequestId) return;

    await applyAutocompleteResult(result, query);
  } catch (err) {
    console.warn('Error in search:', err);
  }
});

v_search?.addEventListener('keydown', event => {
  if (event.key === 'Enter') {
    event.preventDefault();
    const query = v_search.value.trim();
    if (!query) return;

    window.location.href = `/search?q=${encodeURIComponent(query)}`;
  }
});

document.addEventListener('DOMContentLoaded', async () => {
  try {
    if (!v_search || !productList) return;

    enterForYouUi('empty');
    const recs = await getForYouResults();
    renderProducts(recs);
  } catch (err) {
    console.warn('Error loading For You on page load:', err);
  }
});
